import { ModelDef } from '../../CORE/src/common/$models/ModelDef'

/**
 * 見積:家財種別マスタ
 */
export const yhc_kazai_types: ModelDef = {
  tableName: 'yhc_kazai_types',
  tableLabel: '見積:家財種別マスタ',
  primaryKeyColType: 'NUMBER',
  columns: {
    category: {
      type: 'STRING',
      label: '家財カテゴリ',
      validate: { notEmpty: true },
      selectionsWithSelectOptionsMasterGroupName: '家財カテゴリ',
    },
    subCategory: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: '子カテゴリ',
      validate: { notEmpty: true },
      relationshipManyToOne: {
        collectionName: 'yhc_kazai_types_sub_categories',
        labelFormatter: (row) => row.name,
      },
    },
    admin_title: {
      type: 'STRING',
      label: '管理用名称',
      replicable: true,
      validate: { notEmpty: true },
    },
    enabledFrom: {
      type: 'DATETIME',
      label: '有効期間 開始',
      replicable: true,
      validate: { notEmpty: true },
    },
    disabledAt: {
      type: 'DATETIME',
      label: '有効期間 終了',
      replicable: true,
      validate: { notEmpty: true },
    },
    isEnabledOnDebug: {
      type: 'BOOLEAN',
      label: '開発用プレビューで表示',
      replicable: true,
    },
    sort: {
      type: 'NUMBER',
      label: '表示順 (昇順)',
      replicable: true,
      validate: { notEmpty: true },
    },
    name: {
      type: 'STRING',
      label: '表示名 (家財名)',
      replicable: true,
      validate: { notEmpty: true },
    },
    displayNameFormEnabled: {
      type: 'BOOLEAN',
      label: '表示用名称フォームあり',
      inputHelpText: '例えば家財種別"その他"で具体的なアイテム名入力を可能にしたい場合はチェックしてください。',
    },
    thumbnail: {
      type: 'FILE',
      label: '家財アイコン画像',
    },
    hasOriented: {
      type: 'BOOLEAN',
      label: '天地条件あり',
      inputHelpText: 'テレビなど天地が定められている場合はチェックしてください。',
      defaultValue: false,
      inputAttrs: {
        falseLabel: 'なし',
        trueLabel: 'あり',
      },
    },
    receptionDisabled: {
      type: 'BOOLEAN',
      label: '荷受け不可',
      defaultValue: false,
      inputHelpText: 'チェックすると"お荷物の種類"箇所にて表示されますが、選択不可となります。',
    },
    noSizeLimit: {
      type: 'BOOLEAN',
      label: 'サイズ上限なし',
      inputHelpText: '※寸法の合計が450cmを超えてもよい場合はチェックしてください。例：ベッド',
    },
    sizeOptions: {
      type: 'RELATIONSHIP_ONE_TO_MANY',
      label: 'サイズ選択オプション',
      inputComponent: 'SortableRecordList',
      replicable: true,
      width: { xs: 48 },
      relationshipOneToMany: {
        collectionName: 'yhc_kazai_type_size_options',
        fieldName: 'kazai',
        labelFormatter: (rows) => `${rows?.length || 0}件`,
      },
    },
    serviceOptions: {
      type: 'RELATIONSHIP_ONE_TO_MANY',
      label: '選択可能なオプションサービス',
      replicable: true,
      relationshipOneToMany: {
        collectionName: 'yhc_kazai_option_services_kazais',
        fieldName: 'kazai',
        labelFormatter: (rows) => `${rows?.length || 0}件`,
      },
      inputComponent: 'SortableRecordList',
      width: { xs: 48 },
    },
    notice_title: {
      type: 'STRING',
      label: '注意事項タイトル',
      replicable: true,
      inputHelpText:
        '空欄にした場合は 【 (家財名) をご依頼する場合のご注意事項】 として表示されます。',
        width: { xs: 24 },
    },
    notice_text: {
      type: 'RICHTEXT',
      label: '注意事項 文章',
      replicable: true,
      width: { xs: 48 },
    },
  },
}
